import React from 'react';

// Default value is defined in UploadStateContextProvider
export const UploadStateContext = React.createContext({});
